import { theme } from "@familyzone/component-library";
import colors from "./colors";
import shadows from "./shadows";
import tag from "./components/tag";

const rebrandedTheme = {
  ...theme,
  colors,
  shadows,
  components: {
    ...theme.components,
    Tag: tag,
  },
};

export { rebrandedTheme as default, colors, shadows, tag };
